export { default } from "./RoleList";



// WEBPACK FOOTER //
// ./src/components/RoleList/index.ts